import dayjs from 'dayjs';
import { CALL_TREND_FIELDS } from './graph';

// Convert API daily breakdown into chart-friendly series
export const convertToCallChartData = (dailyBreakdown) => {
  if (!dailyBreakdown) return [];
  const dates = Object.keys(dailyBreakdown).sort();

  return [
    {
      id: CALL_TREND_FIELDS.total,
      data: dates.map(date => ({ x: date, y: dailyBreakdown[date].total || 0 }))
    },
    {
      id: CALL_TREND_FIELDS.inbound,
      data: dates.map(date => ({ x: date, y: dailyBreakdown[date].inbound || 0 }))
    },
    {
      id: CALL_TREND_FIELDS.manual,
      data: dates.map(date => ({ x: date, y: dailyBreakdown[date].manual || 0 }))
    },
    {
      id: CALL_TREND_FIELDS.progressive,
      data: dates.map(date => ({ x: date, y: dailyBreakdown[date].progressive || 0 }))
    }
  ];
};

// Demo generator similar to original trend generator (keeps parity)
export const generateCallTrendData = (year, month) => {
  const startDate = dayjs(`${year}-${month.toString().padStart(2, '0')}-01`);
  const daysInMonth = startDate.daysInMonth();
  const trendData = {};

  for (let day = 1; day <= daysInMonth; day++) {
    const dateKey = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    const total = Math.floor(Math.random() * 200) + 50; // 50-250
    const inbound = Math.floor(total * (0.5 + Math.random() * 0.3));
    const manual = Math.floor(total * (0.2 + Math.random() * 0.2));
    const progressive = total - inbound - manual;

    trendData[dateKey] = {
      total,
      inbound,
      manual,
      progressive
    };
  }

  return trendData;
};
